<template>
  <page-view :title="true">
    <a-card>
      <a-form-model
        ref="ruleForm"
        :rules="formRules"
        :model="formData"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        class="form"
      >
        <a-row :gutter="24">
          <a-col :sm="24" :md="24" :xl="24"
            ><a-descriptions title="基本信息"></a-descriptions
          ></a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="出租方式" prop="rentType">
              <a-radio-group v-model="formData.rentType">
                <a-radio
                  :value="item.dictCode"
                  :key="item.dictCode"
                  v-for="item in baseInfo.rentTypeList"
                  >{{ item.dictName }}</a-radio
                >
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="小区" prop="communityName">
              <a-input
                allowClear
                v-model="formData.communityName"
                @click="onSearch"
                placeholder="选择小区"
              />
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="户型" prop="roomLayout">
              <a-select
                allowClear
                showSearch
                v-model="formData.roomLayout"
                placeholder="请选择户型"
              >
                <a-select-option
                  v-for="item in baseInfo.roomLayoutList"
                  :key="item.dictCode"
                  :value="item.dictCode"
                  >{{ item.dictName }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="楼号" prop="buildingNo"
              ><a-input placeholder="请输入楼号" v-model="formData.buildingNo"
            /></a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="单元号" prop="unitNo"
              ><a-input placeholder="请输入单元号" v-model="formData.unitNo"
            /></a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="门牌号" prop="houseNum"
              ><a-input placeholder="请输入门牌号" v-model="formData.houseNum"
            /></a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="当前楼层" prop="floor">
              <a-select
                showSearch
                v-model="formData.floor"
                placeholder="请选择当前楼层"
              >
                <a-select-option
                  v-for="item in baseInfo.floorList"
                  :key="item"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="总楼层" prop="totalFloor">
              <a-select
                showSearch
                v-model="formData.totalFloor"
                placeholder="请选择总楼层"
              >
                <a-select-option
                  v-for="item in baseInfo.totalFloorList"
                  :key="item"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="管家" prop="keeperNo">
              <a-select
                showSearch
                v-model="formData.keeperNo"
                placeholder="请选择管家"
              >
                <a-select-option
                  v-for="item in baseInfo.keeperList"
                  :key="item.userNo"
                  :value="item.userNo"
                  >{{ item.nickName }}-{{ item.mobile }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="采暖方式" prop="heatingType">
              <a-select
                showSearch
                v-model="formData.heatingType"
                placeholder="请选择采暖方式"
              >
                <a-select-option
                  v-for="item in baseInfo.heatingTypeList"
                  :key="item.dictCode"
                  :value="item.dictCode"
                  >{{ item.dictName }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :sm="24">
            <a-form-model-item label="描述" prop="roomIntro">
              <a-input
                style="width: 100%;"
                v-model="formData.roomIntro"
                :rows="4"
                type="textarea"
                placeholder="请输入房源描述"
              />
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="24" :xl="24"
            ><a-descriptions title="其他信息"></a-descriptions
          ></a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="房号" prop="roomNum">
              <a-select
                allowClear
                showSearch
                v-model="formData.roomNum"
                placeholder="请选择房号"
              >
                <a-select-option
                  v-for="item in fangNum"
                  :key="item"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="朝向" prop="roomDirection">
              <a-select
                allowClear
                showSearch
                v-model="formData.roomDirection"
                placeholder="请选择朝向"
              >
                <a-select-option
                  v-for="item in roomDirectionList"
                  :key="item"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="付款方式" prop="payWay">
              <a-select
                allowClear
                showSearch
                v-model="formData.payWay"
                placeholder="请选择付款方式"
              >
                <a-select-option
                  v-for="item in baseInfo.payWayList"
                  :key="item.dictCode"
                  :value="item.dictCode"
                  >{{ item.dictName }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="租金(元/月)" prop="rent">
              <a-input
                type="number"
                suffix="￥"
                v-model="formData.rent"
                placeholder="请输入租金"
              ></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="面积" prop="roomArea">
              <a-input
                type="number"
                suffix="㎡"
                v-model="formData.roomArea"
                placeholder="请输入面积"
              ></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="最短租期(月)" prop="shortLease">
              <a-input
                suffix="月"
                type="number"
                v-model="formData.shortLease"
                placeholder="请输入最短租期"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="限住人数" prop="limitNum">
              <a-input
                suffix="人"
                v-model="formData.limitNum"
                placeholder="请输入限住人数"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="租期" prop="isShortRent">
              <a-select
                allowClear
                showSearch
                v-model="formData.isShortRent"
                placeholder="请选择租期"
              >
                <a-select-option
                  v-for="item in shortRentList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="水费(元)" prop="waterCost">
              <a-input
                suffix="￥"
                v-model="formData.waterCost"
                placeholder="请输入水费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="电费(元)" prop="electricityCost">
              <a-input
                suffix="￥"
                v-model="formData.electricityCost"
                placeholder="请输入电费"
              ></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="天然气费(元)" prop="naturalGasCost">
              <a-input
                suffix="￥"
                v-model="formData.naturalGasCost"
                placeholder="请输入天然气费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="暖气费(元)" prop="heatingCost">
              <a-input
                suffix="￥"
                v-model="formData.heatingCost"
                placeholder="请输入暖气费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="物业费(元/月)" prop="propertyFee">
              <a-input
                suffix="￥"
                v-model="formData.propertyFee"
                placeholder="请输入物业费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="网费(元/月)" prop="internetFee">
              <a-input
                suffix="￥"
                v-model="formData.internetFee"
                placeholder="请输入网费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="12" :xl="8">
            <a-form-model-item label="服务费(元/月)" prop="serviceFee">
              <a-input
                suffix="￥"
                v-model="formData.serviceFee"
                placeholder="请输入服务费"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="24" :xl="24">
            <a-form-model-item label="配件信息">
              <a-checkable-tag
                v-for="item in baseInfo.roomPartList"
                @change="checked => partHandleChange(item.dictCode, checked)"
                :checked="
                  tempPartList.length == 0
                    ? false
                    : tempPartList.indexOf(item.dictCode) > -1
                    ? true
                    : false
                "
                :key="item.dictCode"
              >
                {{ item.dictName }}
              </a-checkable-tag>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="24" :xl="24">
            <a-form-model-item label="图片" prop="fileList">
              <a-upload
                accept="image/*"
                listType="picture-card"
                :multiple="true"
                :fileList="formData.fileList"
                :beforeUpload="beforeUpload"
                :remove="handleRemove"
                @preview="handlePreview"
                :showUploadList="{
                  showPreviewIcon: true,
                  showRemoveIcon: true
                }"
              >
                <div v-if="formData.fileList.length < 10">
                  <a-icon type="inbox" :style="{ fontSize: '30px' }" />
                  <div class="ant-upload-text">选择图片上传</div>
                </div>
              </a-upload>
            </a-form-model-item>
          </a-col>
          <a-col :sm="24" :md="24" :xl="24">
            <div class="operation">
              <a-button
                type="primary"
                :loading="isSubmit"
                @click="save('default')"
                >保存</a-button
              >
              <a-button
                style="margin-left: 8px"
                type="primary"
                :loading="isSubmit"
                @click="save('down')"
                v-if="formData.rentSta == '0'"
                >保存并下架</a-button
              >
              <a-button
                style="margin-left: 8px"
                type="primary"
                :loading="isSubmit"
                @click="save('up')"
                v-if="formData.rentSta == '2'"
                >保存并上架</a-button
              >
              <a-button style="margin-left: 8px" @click="back"
                >返回房源列表</a-button
              >
            </div>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <!-- 小区选择 -->
    <community-modal ref="comModal" @sure="selectCommunity"></community-modal>
    <!-- 图片预览 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel"
      ><img alt="example" style="width: 100%" :src="previewImage"
    /></a-modal>
  </page-view>
</template>

<script>
import { PageView } from "@/layouts";
import CommunityModal from "./stepForm/CommunityModal";
import crypto from "../../../utils/oss/crypto.js";
import hmac from "../../../utils/oss/hmac.js";
import base64 from "../../../utils/oss/base64.js";
import request from "../../../utils/request.js";
import ImageCompressor from "image-compressor.js";
export default {
  components: {
    PageView,
    CommunityModal
  },
  name: "ModifyHouse",
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      formData: {
        keeperNo: undefined,
        fileList: [] //图片
      },
      formRules: {
        //基本
        rentType: [{ required: true, message: "请选择出租方式" }],
        communityName: [{ required: true, message: "请选择小区" }],
        roomLayout: [{ required: true, message: "请选择户型" }],
        floor: [{ required: true, message: "请选择当前楼层" }],
        totalFloor: [{ required: true, message: "请选择总楼层" }],
        buildingNo: [{ required: true, message: "请输入楼号" }],
        keeperNo: [{ required: true, message: "请选择管家" }],
        heatingType: [{ required: true, message: "请选择采暖方式" }],
        unitNo: [{ required: true, message: "请输入单元号" }],
        roomDesc: [{ required: true, message: "请输入房源描述" }],
        houseNum: [{ required: true, message: "请输入门牌号" }],
        //特有
        roomNum: [{ required: true, message: "请选择房号" }],
        roomDirection: [{ required: true, message: "请选择朝向" }],
        payWay: [{ required: true, message: "请选择付款方式" }],
        rent: [{ required: true, message: "请输入租金" }],
        roomArea: [{ required: true, message: "请输入面积" }],
        shortLease: [{ required: true, message: "请输入最短租期" }],
        limitNum: [{ required: true, message: "请输入限住人数" }],
        isShortRent: [{ required: true, message: "请选择租期" }],
        waterCost: [{ required: true, message: "请输入水费" }],
        electricityCost: [{ required: true, message: "请输入电费" }],
        naturalGasCost: [{ required: true, message: "请输入天然气费" }],
        heatingCost: [{ required: true, message: "请输入暖气费" }],
        propertyFee: [{ required: true, message: "请输入物业费" }],
        internetFee: [{ required: true, message: "请输入网费" }],
        serviceFee: [{ required: true, message: "请输入服务费" }],
        fileList: [{ required: true, message: "请上传图片" }]
      },
      userInfo: {},
      oss: {
        key: "",
        secret: "",
        service: "",
        floder: "",
        validTime: ""
      },
      baseInfo: {
        heatingTypeList: [],
        payWayList: [],
        rentTypeList: [],
        roomLayoutList: [],
        roomPartList: [],
        floorList: [],
        totalFloorList: [],
        keeperList: []
      },
      tempPartList: [],
      fangNum: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
      roomDirectionList: [
        "东",
        "南",
        "西",
        "北",
        "东南",
        "东北",
        "西南",
        "西北",
        "南北通透"
      ],
      shortRentList: [
        { id: 0, name: "长租" },
        { id: 1, name: "短租" }
      ],

      previewVisible: false,
      previewImage: "",
      houseNo: "",
      keeperNo: undefined,
      queryParam: null,
      hrefType: "",
      isSubmit: false
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    let query = this.$route.query;
    if (query.keeperNo) {
      this.keeperNo = query.keeperNo;
    }
    if (query.houseNo) {
      this.houseNo = query.houseNo;
      this.getHouseInfo();
    }
    if (query.type) {
      this.hrefType = query.type;
    }
    this.queryParam = query.param;
    this.getOssConfig();
    this.getBaseInfo();
    this.getKeeperList();
  },
  methods: {
    back() {
      if (this.hrefType == "map") {
        window.close();
      } else {
        this.$router.push({
          name: "HouseList",
          query: { param: this.queryParam }
        });
      }
    },
    async getOssConfig() {
      this.$http.roomBksApi
        .findOssConfiguration({ type: "oss_image" })
        .then(res => {
          let info = res.resultObject;
          this.oss.key = info.accessKeyId;
          this.oss.secret = info.accessKeySecret;
          this.oss.service = info.accessService;
          this.oss.floder = info.floderSrc;
          this.oss.validTime = info.validTime;
        });
    },
    async getBaseInfo() {
      this.$http.roomBksApi.findHouseKindData().then(res => {
        Object.assign(this.baseInfo, res.resultObject);
        for (let i = 1; i < 100; i++) {
          this.baseInfo.floorList.push(i);
          this.baseInfo.totalFloorList.push(i);
        }
      });
    },
    async getKeeperList() {
      let param = {};
      param.merchantNo = this.userInfo.merchantNo;
      this.$http.roomBksApi.findKeeperHelpDto(param).then(res => {
        if (res.result == 0) {
          this.baseInfo.keeperList = res.resultObject;
        }
      });
    },
    onSearch() {
      this.$refs.comModal.show();
    },
    selectCommunity(item) {
      this.formData.communityCode = item.communityCode;
      this.formData.communityName = item.communityName;
    },
    getHouseInfo() {
      this.$http.roomBksApi
        .findHouseInfoByHouseNo({ houseNo: this.houseNo })
        .then(res => {
          let obj = Object.assign({}, this.formData);
          this.formData = Object.assign(obj, res.resultObject);
          this.formData.keeperNo = this.keeperNo;
          this.tempPartList = this.formData.roomPartList;
        });
    },

    partHandleChange(tag, checked) {
      const selectKey = Object.assign([], this.tempPartList);
      const nextSelectedTags = checked
        ? [...selectKey, tag]
        : selectKey.filter(t => t !== tag);
      this.tempPartList = nextSelectedTags;
      this.formData.roomParts = this.tempPartList.join();
    },

    handleRemove(file) {
      const index = this.formData.fileList.indexOf(file);
      const newFileList = this.formData.fileList.slice();
      newFileList.splice(index, 1);
      this.formData.fileList = newFileList;
    },
    beforeUpload(file) {
      //压缩图片
      new ImageCompressor(file, {
        quality: 0.6,
        success: res => {
          this.uploadImage(res);
        },
        error: err => {
          this.$message.error("图片上传失败");
        }
      });
      return false;
    },
    uploadImage(file) {
      let server = this.oss.service;
      let OSSAccessKeyId = this.oss.key;
      let AccessKeySecret = this.oss.secret;
      let floder = this.oss.floder;

      let policyText = {
        expiration: this.oss.validTime, //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
        conditions: [
          ["content-length-range", 0, 20971520] // 设置上传文件的大小限制 20mb
        ]
      };
      let policyBase64 = base64.encode(JSON.stringify(policyText));
      let message = policyBase64;
      let bytes = hmac.HMAC(message, AccessKeySecret, {
        asBytes: true
      });
      let signature = crypto.bytesToBase64(bytes);

      let position = file.name.lastIndexOf(".");
      let suffix =
        position == -1
          ? ".png"
          : file.name.substring(position, file.name.length);

      //文件名
      let fileName = "house_" + new Date().getTime() + suffix;
      //文件路径
      let fileUrl = server + floder + fileName;
      let data = new FormData();
      data.append("key", floder + fileName);
      data.append("policy", policyBase64);
      data.append("OSSAccessKeyId", OSSAccessKeyId);
      data.append("success_action_status", "200");
      data.append("signature", signature);
      data.append("file", file);
      request
        .upload("/api/oss/", data)
        .then(res => {
          const item = {};
          item.name = fileName;
          item.url = fileUrl;
          if (!this.formData.smallImage) {
            this.formData.smallImage = fileUrl;
          }
          item.uid = new Date().getTime();
          item.status = "done";
          this.formData.fileList.push(item);
        })
        .catch(err => {});
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    save(type) {
      let param = Object.assign({}, this.formData);
      let arr = [];
      for (let image of this.formData.fileList) {
        arr.push(image.url);
      }
	  param.smallImage = arr[0];
      param.upDownType = type;
      param.images = arr.join();
      param.houseName =
        param.communityName +
        param.buildingNo +
        "-" +
        param.unitNo +
        "-" +
        param.houseNum +
        "-" +
        param.roomNum;
      this.isSubmit = true;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$http.roomBksApi.modifyHouseInfo(param).then(res => {
            this.isSubmit = false;
            if (res.result == 0) {
              if (res.resultObject == 0) {
                this.back();
                this.$message.success("保存成功");
              } else if (res.resultObject == 1) {
                this.$notification.error({
                  message: "提示",
                  description: "商户下存在相同的房源信息"
                });
              } else if (res.resultObject == 2) {
                this.back();
                this.$notification.warning({
                  message: "提示",
                  description:
                    "与其他商户存在相同房源信息，目前该房源属于下架状态，请知悉"
                });
              }
            }
          });
        } else {
          this.isSubmit = false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item-label {
  width: 105px !important;
}
.gallery {
  display: flex;
  flex-wrap: wrap;
  .gallery-item {
    height: 100px;
    width: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.operation {
  text-align: center;
  margin: 20px auto 5px;
}
</style>
